/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Loader, Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/createembed/createembed_styles';



/* ========== ~~~~~~~~~~ CTA : CREATE EMBED BUTTON ~~~~~~~~~~ ========== */
const CreateEmbedButton = (props) => {
	return (
		<Button
			type={'action'}
			action={props.handleCreateEmbed}
			variant={props.variant ? props.variant : `action`}
			name={`create-embed`}
			text={props.creatingEmbed ? `Creating Embed...` : `Create Embed`}
			icon={<Loader />}
			state={`creating-${props.creatingEmbed}`}
			klass={props.classes.createEmbed}
		/>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CreateEmbedButton);
